import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import control from './control.js'
import wrapper from './wrapper.js'

export default contract({
  control: array([
    control
  ]),
  wrapper: array([
    wrapper
  ])
})